import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    width: 100%;
    min-height: 100%;
    border-radius: 16px;
    overflow: hidden;
    background-color: ${theme.v3.colors.brand.snappyBlue[95]};

    @media (max-width: ${theme.v3.breakpoints.sm}) {
      height: auto;
    }
  `}
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  gap: 24px;
  padding: 16px 24px;
`;

export const Dots = styled.div`
  display: flex;
  flex: 1;
  gap: 16px;
  justify-content: center;
`;

export const Dot = styled.span<{ $filled?: boolean }>`
  ${({ theme, $filled }) => css`
    flex: 1;
    height: 8px;
    border-radius: 9999px;
    background-color: ${$filled ? theme.v3.colors.neutral[80] : theme.v3.colors.neutral[100]};
  `}
`;

export const CloseButton = styled.button`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    border: none;
    background: none;
    cursor: pointer;

    &:focus-visible {
      outline: 2px solid ${theme.v3.colors.brand.snappyBlue[15]};
      outline-offset: 2px;
    }
  `}
`;

export const IllustrationArea = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 345px;
  padding: 0 24px;
  box-sizing: border-box;
`;

export const Illustration = styled.img`
  display: block;
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
`;

export const BodyContent = styled.div`
  display: flex;
  flex-direction: column;
  padding: 24px 24px;
`;

export const TextContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 16px 0 0;
`;

export const Footer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 8px 0 0;
`;

export const AdvanceButton = styled.button`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 48px;
    height: 48px;
    border: none;
    border-radius: 1000px;
    background-color: ${theme.v3.colors.brand.snappyBlue[50]};
    cursor: pointer;

    &:focus-visible {
      outline: 2px solid ${theme.v3.colors.brand.snappyBlue[15]};
      outline-offset: 2px;
    }
  `}
`;

export const CtaButton = styled.button`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    width: 100%;
    height: 48px;
    border: none;
    border-radius: 1000px;
    background-color: ${theme.v3.colors.brand.snappyBlue[50]};
    cursor: pointer;
    font-family: ${theme.v2.font.family.primary};
    font-size: 16px;
    font-weight: ${theme.v2.font.weights.medium};
    color: ${theme.v3.colors.neutral[100]};

    &:focus-visible {
      outline: 2px solid ${theme.v3.colors.brand.snappyBlue[15]};
      outline-offset: 2px;
    }
  `}
`;

export const Title = styled.h2`
  ${({ theme }) => css`
    margin: 0;
    font-family: ${theme.v2.font.family.primary};
    font-size: 20px;
    font-weight: ${theme.v2.font.weights.medium};
    line-height: 1.5;
    color: ${theme.v3.colors.brand.snappyBlue[15]};
  `}
`;

export const Description = styled.p`
  ${({ theme }) => css`
    margin: 0;
    font-family: ${theme.v2.font.family.primary};
    font-size: 18px;
    font-weight: ${theme.v2.font.weights.regular};
    line-height: 1.5;
    color: ${theme.v3.colors.brand.snappyBlue[15]};
  `}
`;
